import { x } from '@xstyled/styled-components';
import React, { ComponentProps, useEffect, useState } from 'react';
import ArrowIcon from '~/assets/icons/arrow.svg';
import { styled } from '@xstyled/styled-components';
import { useEditorStore } from '~/shell/Store';
import useIsDarkMode from '~/lib/themes/hooks/useIsDarkMode';

const ArrowIconStyled = styled(ArrowIcon)`
  path {
    fill: ${({ fill }) => fill};
  }
`;

export const IconButton = (props: ComponentProps<typeof x.button>) => {
  const { contentEditable } = useEditorStore();
  const isDarkMode = useIsDarkMode();
  const [isDark, setIsDark] = useState(isDarkMode);

  useEffect(() => {
    if (contentEditable) {
      return;
    }

    setIsDark(isDarkMode);
  }, [isDarkMode, contentEditable]);

  return (
    <x.button
      w="51px"
      h="51px"
      bg={isDark ? 'rgba(255,255,255,0.2)' : 'rgba(111,111,111,0.2)'}
      borderRadius="50%"
      zIndex={200}
      display="flex"
      alignItems="center"
      justifyContent="center"
      alignSelf="center"
      justifySelf="center"
      transition="all 0.3s ease-out"
      cursor={{ disabled: 'not-allowed' }}
      opacity={{ disabled: '0.5' }}
      {...props}
    >
      <ArrowIconStyled fill={isDark ? '#FFF' : '#000'} />
    </x.button>
  );
};
